/**
 * Funções de conveniência para uso em módulos não-React (como httpClient)
 * Estas funções usam o provider atual baseado em variáveis de ambiente
 */
import { createAuthProvider } from './authProviderFactory';
import { UserProfile } from '../types';

// Cache do provider para evitar criar múltiplas instâncias
let cachedProvider: ReturnType<typeof createAuthProvider> | null = null;

/**
 * Obtém ou cria o provider de autenticação
 */
const getAuthProvider = () => {
    if (!cachedProvider) {
        cachedProvider = createAuthProvider();
    }
    return cachedProvider;
};

/**
 * Obtém o token de acesso atual
 */
export const getToken = (): string | undefined => {
    return getAuthProvider().getToken();
};

/**
 * Atualiza o token se necessário
 * @param minValidity - Validade mínima em segundos antes de renovar
 * @returns Promise<boolean> - Se o token foi renovado
 */
export const updateToken = async (minValidity: number = 30): Promise<boolean> => {
    return getAuthProvider().updateToken(minValidity);
};

/**
 * Verifica se o usuário está autenticado
 */
export const isAuthenticated = (): boolean => {
    return getAuthProvider().isAuthenticated();
};

/**
 * Obtém informações do usuário do token
 * @returns UserProfile | null - Informações do usuário ou null se não autenticado
 */
export const getUserInfo = (): UserProfile | null => {
    const info = getAuthProvider().getUserInfo();
    return info as UserProfile | null;
};

/**
 * Executa logout (limpa tokens e redireciona conforme o provider)
 * Usado pelo httpClient quando recebe 403 ROLE_NOT_ALLOWED
 */
export const performLogout = (): void => {
    getAuthProvider().logout();
};
